(function () {
  'use strict';

  var selector = '.hp-anim';
  var designMode = Boolean(window.Shopify && window.Shopify.designMode);
  var reducedMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function enableDesignMode() {
    designMode = true;
    document.documentElement.classList.add('hp-design-mode');
  }

  if (designMode) {
    enableDesignMode();
  }

  function getAnimatedElements(root) {
    var elements = [];

    if (!root) {
      root = document;
    }

    if (root.nodeType === 1 && root.matches(selector)) {
      elements.push(root);
    }

    if (root.querySelectorAll) {
      elements = elements.concat(Array.from(root.querySelectorAll(selector)));
    }

    return elements;
  }

  function reveal(root) {
    getAnimatedElements(root).forEach(function (element) {
      element.classList.add('hp-anim--visible');

      if (observer) {
        observer.unobserve(element);
      }
    });
  }

  function observe(root) {
    var elements = getAnimatedElements(root);

    if (!elements.length) {
      return;
    }

    if (designMode || reducedMotion || !('IntersectionObserver' in window)) {
      reveal(root);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('hp-anim--visible');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -30px 0px'
      });
    }

    elements.forEach(function (element) {
      if (!element.classList.contains('hp-anim--visible')) {
        observer.observe(element);
      }
    });
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enableDesignMode();
    observe(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    enableDesignMode();
    reveal(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    enableDesignMode();

    var animatedParent = event.target.closest
      ? event.target.closest(selector)
      : null;

    if (animatedParent) {
      reveal(animatedParent);
    }
  });
})();
